import React, { Component } from 'react';
import { BasicSetup } from '../../../components/basicsetup/BasicSetup';

class ItemGroupSetup extends Component {
  render() {
    return (
      <BasicSetup
        resourcename="InvGroup/ItemGroup"
        humanname="Item Group"
        blockEditFromId={99999}
        blockEditToId={99999}
        showId={true}
        showClearFilter={true}
        isHeaderLeftAlign={true}
        {...this.props}
      />
    );
  }
}

export { ItemGroupSetup };



// WEBPACK FOOTER //
// ./src/pages/inventory/itemgroupsetup/ItemGroupSetup.js